// @flow
import React from "react";
import { withToastManager } from "react-toast-notifications";
// Traduction
import { injectIntl } from "react-intl";
import { YOU_CALL_YOU_GO_DG_ID } from "../../../../const";
import DriverGroup from "../../DriverGroup";

class YouCallYouGo extends React.Component<Props, State> {
	render() {

		return <DriverGroup {...this.props} displayHeaderFooter={true} driver_group={YOU_CALL_YOU_GO_DG_ID}/>;
	}
}

export default injectIntl(withToastManager(YouCallYouGo));
